import React from 'react';
import Routes from './routes/index';

function App() {
  return <Routes />
}

export default App;
